import "@/App.css";
import "@/index.css";
import { useEffect, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { useLenis } from "@/hooks/useLenis";
import { SiteHeader } from "@/components/site/SiteHeader";
import { SiteFooter } from "@/components/site/SiteFooter";
import { SalesIQController } from "@/components/site/SalesIQController";

const Home = lazy(() => import("@/pages/Home"));
const Ecosystem = lazy(() => import("@/pages/Ecosystem"));
const OurStory = lazy(() => import("@/pages/OurStory"));
const Destinations = lazy(() => import("@/pages/Destinations"));
const BewareScams = lazy(() => import("@/pages/BewareScams"));
const Contact = lazy(() => import("@/pages/Contact"));
const Login = lazy(() => import("@/pages/Login"));
const AdminLeads = lazy(() => import("@/pages/AdminLeads"));

function PageFallback() {
  return (
    <div className="flex min-h-[100svh] items-center justify-center bg-space" data-testid="page-loading">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-white/15 border-t-[var(--blue)]" />
    </div>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Layout() {
  useLenis();
  return (
    <div className="grain relative min-h-screen bg-space">
      <ScrollToTop />
      <SiteHeader />
      <main>
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <SalesIQController />
      <Suspense fallback={<PageFallback />}>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/our-story" element={<OurStory />} />
            <Route path="/destinations" element={<Destinations />} />
            <Route path="/ecosystem" element={<Ecosystem />} />
            <Route path="/beware-scams" element={<BewareScams />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
          </Route>
          <Route path="/admin/leads" element={<AdminLeads />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
